'use strict';

import { Entity } from '../Entity';
import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class IndAlternateId extends Entity {
  protected id;
  protected indId;
  protected provider: UserIntegrationProvider;
  protected contactId;
  protected listId;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    if (data.provider) {
      const provider = new UserIntegrationProvider();
      provider.hydrate(data.provider);

      this.provider = provider;
    }
    this.contactId = data.contactId;
    this.listId = data.listId;
  }

  public getId() {
    return this.id;
  }

  public getIndId() {
    return this.indId;
  }

  public getProvider() {
    return this.provider;
  }

  public getContactId() {
    return this.contactId;
  }

  public getListId() {
    return this.listId;
  }
}
